/* L&P 2026-09-24. In the cart, "+" on a paid watch adds one more 1+1 PAIR:
   the same paid watch + the gift watch. A plain +1 made a third watch at full
   price that checkout still tagged "1+1". Rendered by cart-drawer.liquid and
   main-cart-items.liquid as data-lp-pair-paid / data-lp-pair-gift. */
(function () {
  if (window.__lpCartPair) return;
  window.__lpCartPair = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var busy = false;
  document.addEventListener("click", function (event) {
    var btn = event.target.closest && event.target.closest("[data-lp-pair-paid]");
    if (!btn) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    var row = btn.closest(".cart-item");
    if (row) row.classList.add("is-loading");
    var drawer = document.querySelector("cart-drawer");
    var inDrawer = !!(drawer && drawer.contains(btn));
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          { id: Number(btn.getAttribute("data-lp-pair-paid")), quantity: 1 },
          { id: Number(btn.getAttribute("data-lp-pair-gift")), quantity: 1 }
        ],
        sections: "cart-drawer,cart-icon-bubble",
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); }).then(function (json) {
      busy = false;
      if (json.status) throw new Error(json.description || "add failed");
      if (inDrawer && typeof drawer.renderContents === "function" && json.sections && json.sections["cart-drawer"]) {
        drawer.renderContents(json);
      } else {
        window.location.reload();
      }
    }).catch(function () {
      busy = false;
      window.location.reload();
    });
  }, true);
})();
